import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Check from "@mui/icons-material/Check";
import Cancel from "@mui/icons-material/Cancel";

const styles = {
  simpleTextContainer: {
    width: 14,
    height: 14,
    flexShrink: 0,
    borderRadius: "3px",
    mr: 1,
    mt: "2px",
  },
};

const TagOptions = ({
  selectedTags,
  option,
  props,
  handleClick,
  handleTagDelete,
  colorOptions = [],
}) => {
  let filterColor = colorOptions.find(
    (color) => color?.id == option.tagColorId
  );

  return (
    !selectedTags.some((tag) => tag.id === option.id) && (
      <li key={option.id} {...props} onClick={() => handleClick(option)}>
        {option.tagColorId ? (
          <Chip
            key={option.name}
            label={option.name}
            onDelete={
              handleTagDelete ? (e) => handleTagDelete(e, option) : false
            }
            style={{
              backgroundColor: filterColor?.code,
              color: filterColor?.textCode,
            }}
            deleteIcon={
              handleTagDelete ? (
                <Cancel
                  style={{ fontSize: "20px", color: filterColor?.textCode }}
                />
              ) : null
            }
          />
        ) : (
          <>
            <Box
              component="span"
              sx={styles.simpleTextContainer}
              style={{ backgroundColor: option?.code }}
            />
            <Box sx={{ flexGrow: 1 }}>{option.name}</Box>
            {selectedTags.some((tag) => tag.id === option.id) && (
              <Check sx={{ opacity: 0.6, width: 18, height: 18, ml: 1 }} />
            )}
          </>
        )}
      </li>
    )
  );
};

export default TagOptions;
